// 首页
const home = {
  path: '/home',
  name: 'home',
  component: 'LAYOUT',
  redirect: '/home/index',
  meta: {
    orderNo: 10,
    icon: 'icon-canbaodangan',
    title: '', //头部菜单名
    hideChildrenInMenu: true,
    // 是否头部菜单（true为头部菜单，false不是头部菜单）（当showInTopMenu为false时可以不返这个字段，头部菜单都为true，左侧菜单都为false）
    showInTopMenu: true,
    // 是否展示左侧菜单（true为不展示，false为展示）
    hiddenSlideBar: true,
    authorization: true,
  },
  children: [
    {
      path: 'index',
      name: 'homeIndex',
      component: '/home/index',
      meta: {
        title: '', //浏览器展示的title
        authorization: true,
        orderNo: 1,
      },
    },
  ],
};

// 服务
const serve = {
  path: '/serve',
  name: 'Serve',
  component: 'LAYOUT',
  redirect: '/serve/index',
  meta: {
    orderNo: 30,
    icon: 'icon-canbaodangan',
    title: '',
    hideChildrenInMenu: true,
    // 是否头部菜单（true为头部菜单，false不是头部菜单）（当showInTopMenu为false时可以不返这个字段，头部菜单都为true，左侧菜单都为false）
    showInTopMenu: true,
    // 是否展示左侧菜单（true为不展示，false为展示）
    hiddenSlideBar: true,
    authorization: true,
  },
  children: [
    {
      path: 'index',
      name: 'ServeIndex',
      component: '/serve/index.vue',
      meta: {
        title: '',
        authorization: true,
        orderNo: 1,
      },
    },
    // {
    //     path: 'detail/:id?',
    //     name: 'ServeDetail',
    //     component: '/search/detail.vue',
    //     meta: {
    //         title: '详情',
    //         authorization: true,
    //         orderNo: 2,
    //         isHideFooter: true,
    //     }
    // },
  ],
};

// 福利
const welfare = {
  path: '/welfare',
  name: 'welfare',
  component: 'LAYOUT',
  redirect: '/welfare/index',
  meta: {
    orderNo: 30,
    icon: 'icon-canbaodangan',
    title: '',
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'index',
      name: 'welfareIndex',
      component: '/welfare/index.vue',
      meta: {
        title: '',
        authorization: true,
        orderNo: 1,
      },
    },
  ],
};

// 我的
const my = {
  path: '/mine',
  name: 'mine',
  component: 'LAYOUT',
  redirect: '/mine/index',
  meta: {
    orderNo: 20,
    icon: 'icon-canbaodangan',
    title: '',
    hideChildrenInMenu: true,
    // 是否头部菜单（true为头部菜单，false不是头部菜单）（当showInTopMenu为false时可以不返这个字段，头部菜单都为true，左侧菜单都为false）
    showInTopMenu: true,
    // 是否展示左侧菜单（true为不展示，false为展示）
    hiddenSlideBar: true,
    authorization: true,
  },
  children: [
    {
      path: 'index/:name?',
      name: 'mineIndex',
      component: '/mine/index.vue',
      meta: {
        title: '',
        authorization: true,
        orderNo: 1,
      },
    },
  ],
};

export const headData = [home, serve, welfare, my];
